/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/emailStatusTab"/>
import * as ko from 'knockout';
import { EmailStatusWithSections } from 'Core/Medius.Core.Web/Scripts/components/emailStatusTab/emailStatusWithSections';
import { getDocumentContext } from '../../Medius/mediusUtils';

export default class EmailStatusTab {
    public emailStatusWithSections: any;
    public documentId: string;
    public companyId: number;
    public importTrackingId?: string | null;
    public type?: string;
    public hashFiles?: any[];
    public userTaskId?: number;

    constructor(
        companyId?: number,
        documentId?: string,
        importTrackingId?: string | null,
        type?: string,
        hashFiles?: any[],
        ctx?: any | null,
        userTaskId?: number,
    ) {
        ctx = ko.toJS(ctx);
        const documentContext = ctx ? getDocumentContext(ctx) : null;
        this.documentId = documentId || '0';
        this.companyId = companyId;
        this.importTrackingId = importTrackingId || undefined;
        this.type = type ? type.split(",", 1)[0].trim() : documentContext?.DocumentTypeName; // to get the actual document type name
        this.hashFiles = ko.toJS(hashFiles);
        this.userTaskId = userTaskId ? userTaskId : documentContext?.TaskId;
        this.emailStatusWithSections = {
            functionComponent: EmailStatusWithSections,
            props: {
                documentId: this.documentId,
                companyId: this.companyId,
                importTrackingId: this.importTrackingId,
                documentType: this.type,
                hashFiles: this.hashFiles.map(hf => ({ Type: hf.Type, Hash: hf.Hash })),
                userTaskId: this.userTaskId,
            }
        };
    }
}
